import React from "react";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import RuleDetails from "./RuleDetails";

// Presentational card for a single repricing rule. The interactive header (the
// toggle badge) and footer (usage + actions) live here; the read-only body
// (summary + chips) is shared with the apply dialog via RuleDetails. All actions
// are delegated to the parent via callbacks; this component holds no
// data-fetching logic.
const RuleCard = ({rule, t, busy, onToggle, onLinked, onEdit, onDelete}) => {
    const active = !!rule.is_active;
    const productCount = rule.linked_product_count || 0;
    const campaignCount = rule.linked_campaign_count || 0;

    const iconBtn = (icon, tip, onClick, danger) => (
        <Button icon={icon} className={"p-button-rounded p-button-text" + (danger ? " p-button-danger" : "")}
                tooltip={tip} tooltipOptions={{position: 'top'}} onClick={onClick}/>
    );

    return (
        <div style={{border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, background: '#fff',
            display: 'flex', flexDirection: 'column', gap: 12}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8}}>
                <span style={{fontWeight: 700}}>{rule.name}</span>
                <span onClick={() => !busy && onToggle(rule)}
                      title={active ? t('pricing_template.toggle_passive') : t('pricing_template.toggle_active')}
                      style={{cursor: busy ? 'default' : 'pointer'}}>
                    <Tag value={active ? t('actions.active') : t('actions.passive')}
                         severity={active ? 'success' : null}
                         style={active ? undefined : {background: '#e5e7eb', color: '#6b7280'}}
                         icon={busy ? 'pi pi-spin pi-spinner' : undefined}/>
                </span>
            </div>

            <RuleDetails rule={rule} t={t}/>

            <div style={{borderTop: '1px solid #e5e7eb', paddingTop: 10, display: 'flex',
                alignItems: 'center', justifyContent: 'space-between', gap: 8}}>
                <div style={{display: 'flex', gap: 12, color: '#9ca3af', fontSize: 12}}>
                    <span><i className="pi pi-box" style={{fontSize: 13, marginRight: 4}}/>{t('pricing_template.used_in_products', {count: productCount})}</span>
                    <span><i className="pi pi-megaphone" style={{fontSize: 13, marginRight: 4}}/>{t('pricing_template.used_in_campaigns', {count: campaignCount})}</span>
                </div>
                <div style={{display: 'flex'}}>
                    {iconBtn('pi pi-link', t('pricing_template.linked_products'), () => onLinked(rule))}
                    {iconBtn('pi pi-pencil', t('pricing_template.edit'), () => onEdit(rule))}
                    {iconBtn('pi pi-trash', t('pricing_template.delete'), () => onDelete(rule), true)}
                </div>
            </div>
        </div>
    );
};

export default RuleCard;
